import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { ModalProvider } from "react-modal-hook";
import App from "./components/App";
import Config from "./components/Config";
import reducers from "./reducers";
import ai from "./middleware/ai-middleware";
import RutaTematica from "./components/RutaTematica";
import { getQS } from "./components/utilerias-components";
import { MemoryRouter as Router } from "react-router-dom";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk, ai)),
);

const init = (config = {}) => {
  if (!config.appElement) config.appElement = "root";
  const [path, ui, , Idt] = getQS();
  let lang = "es";
  if (path.length > 1) {
    if (path[1].lastIndexOf("_en") > -1) lang = "en";
  } else if (path[0].indexOf("_en_") > -1) lang = "en";
  config.lang = lang;
  config.varTime = lang === "es" ? "Periodo" : "Time";
  if (Idt === null && /^(BISE|IND)\d*/.test(path[0])) {
    document.getElementById("rootEncabezado").hidden = true;
    document.getElementById("PiePagina").hidden = true;
  }
  ReactDOM.render(
    <Provider store={store}>
      <ModalProvider>
        <Config config={config}>
          <App />
          {(Idt !== null || ! /^(BISE|IND)\d*/.test(path[0])) &&
          ReactDOM.createPortal(
            <Router>
              <RutaTematica />
            </Router>,
            document.getElementById("rootRuta")
          )
        }
        </Config>
      </ModalProvider>
    </Provider>,
    document.getElementById(config.appElement),
  );
};
init();
export { init };
